import React, { useState, useEffect } from 'react'
import Transparent from '../images/transparent.gif'
import Loading from '../images/loading40.gif'
import axios from 'axios';

export default function FancyBook(props) {

    const [refresh, setrefresh] = useState(true);
    const [bookList, setbookList] = useState([]);

    useEffect(() => {

        // if(!props.userid) return;
        axios.post('https://millionbet247.com/api/agent/newclientFancyExposure', {
            id: props.userid,
            token: props.token,
            eventId: props.eventId,
            selectionId: props.selection


        }).then(result => {
            setrefresh(false);
            if (result.status === 200) {

                var res = [];
                for (let key in result.data) {

                    if (result.data.hasOwnProperty(key)) {
                        let obj = {};
                        obj.run = key;
                        obj.position = result.data[key];

                        res.push(obj);


                    }
                }
                if (res.length < 7) {
                    res = [' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' ', ' '];
                }
                //console.log(res)
                setbookList(res);

            }

        }
        ).catch(e => {
            //setIsError(true);
        });
    }, [])
    return (
        <React.Fragment>

            {refresh === true &&
                <div class="loading-overlay" id="loading">
                    <div class="loading-wrap" style={{ display: " flex" }}>
                        <div class="loading">
                            <div></div>
                            <div></div>
                        </div>
                        <p>Loading...</p>
                    </div>
                </div>}

            <div id="fancyBetBookLeftSide" className="overlay" style={{ display: 'flex' }}>
                <div id="sideWrap" className="side-wrap full-pop">
                    <title>lc247</title>
                    <div className="side-head">
                        <h3 className>Book Position</h3>
                        <a className="close" onClick={() => { props.handleFancyBook(false); }}>Close</a>
                    </div>

                    <div id="sideContent" className="side-content">
                        <div className="path-wrap">
                            <ul>
                                <li id="headerName">{props.runner}</li>
                            </ul>
                        </div>
                        {refresh === false &&
                            <table id="table" className="table table-fancy">
                                <tbody>
                                    <tr>
                                        <th width="40%">Runs</th>
                                        <th width="60%">Amount</th>
                                    </tr>

                                    {bookList.map((item, index) => {
                                        return (
                                            <tr id="runsEx" style={{ display: 'table-row' }}>
                                                <td id="runs" className="col-back"><strong>{item.run}</strong></td>
                                                <td id="exposure" className="col-back"><strong> {item != ' ' ? parseFloat(item.position).toFixed(2) : item.position}</strong></td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>}
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}